import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceBoardusersState = (state: AppState) =>
	state.deviceBoardusers;


export const selectBoardUsersListsRespDataLoading = createSelector(
	selectDeviceBoardusersState,
	(state) => state.loading
);
export const selectBoardUsersListsRespData = createSelector(
	selectDeviceBoardusersState,
	(state) => state.boardUsersListsRespData
);
export const selectBoardUsersVersionLists = createSelector(
	selectDeviceBoardusersState,
	(state) => state.versionLists
);
export const selectBoardUsersExporting = createSelector(
	selectDeviceBoardusersState,
	(state) => state.exporting
);
export const selectBoardUsersExported = createSelector(
	selectDeviceBoardusersState,
	(state) => state.exported
);
export const selectBoardUsersUpdating = createSelector(
	selectDeviceBoardusersState,
	(state) => state.updating
);
export const selectBoardUsersUpdated = createSelector(
	selectDeviceBoardusersState,
	(state) => state.updated
);
export const selectBoardUsersImporting = createSelector(
	selectDeviceBoardusersState,
	(state) => state.importing
);
export const selectBoardUsersImported = createSelector(
	selectDeviceBoardusersState,
	(state) => state.imported
);
